import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const configs = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1775285018530/5-pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1775285018328/5-m.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1775285018328/5-m.jpg',
        label: t('C_label'),
        title: t('C_title'),
        subTitle: t('C_subTitle'),
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range5`} data-section-id="D3-C" id='D3-C'>
            <EfSection {...configs} theme="white" position="hover" />
        </div>
    );
}
